import createPersistedState from 'vuex-persistedstate'

export default ({ store }) => {
  createPersistedState({
    paths: [
      'product.persistedMaterial',
      'product.persistedDeviceId',
      'product.persistedCaseTypeId',
      'product.persistedCaseDeviceId',
      'product.restoreFromGoogle',
      'minicart.items',
      'minicart.userId',
      'minicart.orderNumber',
      'minicart.guestToken',
      'minicart.zipCode',
    ],
  })(store)
}
